import { ANONYMOUS_USERNAME } from "constants/userConstants";
import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";
import { all, select, takeLatest } from "redux-saga/effects";
import { getCurrentUser } from "selectors/usersSelectors";

function* handleChromeExtensionReload() {
  // Only proceed if the window is opened by the extension
  if (!window.opener) return;

  const currentUser: ReturnType<typeof getCurrentUser> =
    yield select(getCurrentUser);

  if (currentUser?.email === ANONYMOUS_USERNAME) return;

  window.opener.postMessage(
    {
      type: "RELOAD_APPSMITH_AGENTS_EXTENSION",
    },
    "*",
  );
}

export default function* chromeExtensionSagas() {
  yield all([
    // Listen for user fetch success and logout events to reload extension
    takeLatest(
      ReduxActionTypes.FETCH_USER_DETAILS_SUCCESS,
      handleChromeExtensionReload,
    ),
  ]);
}
